import { useState, useEffect, useRef } from 'react'

import { Table, Panel, Grid, Icon, Drawer, Row, Col } from 'rsuite'
import { findIndex } from 'lodash-es'
import ExpertName from '../../view/ExpertName'
import { useSelector } from 'react-redux'
import SaveButton from '../../buttons/saveButton/SaveButton'
import ViewButton from '../../buttons/viewButton/ViewButton'
import CancelButton from '../../buttons/cancelButton/CancelButton'

export default function ExpertListFromAICarousel({
  data: _data,
  selectedExpert,
  isEditable,
  isDisableOnline,
  // activePage = 1,
  // pageCount = 1,
  isSubProject,
  isHideWorkload,
  onClickSelect = () => {},
  onClickOnline = () => {},
  // handleChangePage = () => {},
  onReload = () => {},
  pagination = true,
  lengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  loading,
  isAll,
  totalSize,
  suggestionInfo,
}) {
  const { Column, HeaderCell, Cell } = Table
  const SELECTED_EXPERT = 'selectedExpert'
  const { isExpanded } = useSelector((state) => state.schemaSidebar)

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)
  const [detailWidth, setDetailWidth] = useState(500)
  const [tableData, setTableData] = useState(_data)

  const [showDrawer, setShowDrawer] = useState()
  const [showDrawerInfoAll, setShowDrawerInfoAll] = useState()

  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)

  let fontSize = localStorage.getItem('fontSize')

  const carouselData = tableData || []

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  let _sendedExpert = []
  try {
    _sendedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
  } catch (e) {}

  const [sendedExpert, setsendedExpert] = useState(_sendedExpert.filter((i) => i.sendConsiderDate))

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setTableData(_data)
  }, [_data])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
      setTableData([])
      setTimeout(() => {
        setTableData(tableData)
      }, 0)
    }
  }, [containerRef, windowWidth, isExpanded])

  useEffect(() => {
    let callWidth =
      containerWidth -
      50 -
      240 -
      100 -
      100 -
      (isEditable ? 100 : 0) -
      (isEditable && isSubProject ? 70 : 0)
    callWidth <= 500 ? (callWidth = 500) : callWidth
    setDetailWidth(containerWidth > 500 ? callWidth : 500)
  }, [containerWidth])

  const defaultCheckedIsSelected = (rowData) => {
    const dataIndex = findIndex(selectedExpert, { id: rowData.id })
    if (dataIndex !== -1) {
      return selectedExpert[dataIndex].isSelected
    }
    return false
  }

  const defaultCheckedIsOnline = (rowData) => {
    const dataIndex = findIndex(selectedExpert, { id: rowData.id })
    if (dataIndex !== -1) {
      return selectedExpert[dataIndex].isOnline
    }
    return rowData.isOnline
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    onReload(dataKey, 1)
  }
  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    onReload(displayLength, dataKey)
  }

  const getData = () => {
    return tableData?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const onClickShowInfoAll = () => {
    setShowDrawerInfoAll(true)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }} align="center">
      <Grid fluid>
        <Icon icon="user" size="2x" style={{ marginTop: 15 }} />
      </Grid>
    </Cell>
  )

  const SubnameCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props}>
        <Grid fluid>
          <ExpertName
            name={rowData[dataKey] || rowData.firstName}
            email={rowData.email}
            group={rowData.group}
          />
        </Grid>
      </Cell>
    )
  }

  const SuggestRankTag = ({ item }) => {
    if (!item.suggestRankLabel) {
      return null
    }

    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 86,
          padding: '8px 12px',
          borderRadius: 18,
          backgroundColor: item.suggestRankColor || '#3498ff',
          color: '#fff',
          fontWeight: 600,
          lineHeight: 1.2,
          //width: '100%',
          fontSize: '0.8rem',
        }}
      >
        {item.suggestRankLabel}
      </span>
    )
  }

  const CustomLeftArrow = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        style={{
          ...arrowStyle,
          left: '10px',
        }}
      >
        ‹
      </button>
    )
  }

  const CustomRightArrow = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        style={{
          ...arrowStyle,
          right: '10px',
        }}
      >
        ›
      </button>
    )
  }

  const CustomDot = ({ onClick, active }) => {
    return (
      <button
        onClick={onClick}
        style={{
          width: active ? '24px' : '12px',
          height: '12px',
          borderRadius: '10px',
          border: 'none',
          margin: '0 4px',
          padding: 0,
          cursor: 'pointer',
          backgroundColor: active ? '#2da888' : '#d9d9d9',
          transition: 'all 0.3s ease',
        }}
      />
    )
  }

  const renderSuggestionInfoAll = (suggestionInfo) => {
    if (!suggestionInfo || suggestionInfo.length === 0) {
      return <p>ไม่มีข้อมูล</p>
    }

    return (
      <div style={{ padding: 10 }}>
        {suggestionInfo.map((item, index) => (
          <div key={index} style={{ marginBottom: 10 }}>
            <strong>{`${index + 1}. `}</strong>
            <strong>{item.name || '-'}</strong>
            <div dangerouslySetInnerHTML={{ __html: item.suggestDesc }}></div>
            <hr />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div ref={containerRef}>
      <Row>
        <ViewButton icon="info" onClick={onClickShowInfoAll}>
          {`รายละเอียดของผู้ทรงคุณวุฒิ ที่ AI แนะนำ ทั้งหมด`}
        </ViewButton>
      </Row>
      <Panel
        style={{ marginTop: 10 }}
        header="รายชื่อผู้ทรงคุณวุฒิ"
        collapsible
        bodyFill
        defaultExpanded
      >
        {/* <Carousel
          rewindWithAnimation={true}
          swipeable={false}
          draggable={false}
          showDots={true}
          responsive={responsive}
          //ssr={true} // means to render carousel on server-side.
          infinite={true}
          //autoPlay={this.props.deviceType !== "mobile" ? true : false}
          autoPlaySpeed={1000}
          keyBoardControl={true}
          customTransition="transform 500ms ease-in-out"
          transitionDuration={500}
          containerClass="carousel-container"
          // removeArrowOnDeviceType={['tablet', 'mobile']}
          //deviceType={this.props.deviceType}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
          customDot={<CustomDot />}
        >
          {carouselData.map((item, index) => {
            var selected = selectedExpert?.some((e) => e.id == item.id)
            // if(selectedExpert?.some((e) => e.id == item.id)){
            //   return
            // }
            return (
            <Panel
              key={item.id || index}
              defaultExpanded
              bordered
              shaded
              style={{ margin: '0 8px', minHeight: 210 }}
            >
              <div
                style={{
                  minHeight: 170,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  gap: 10,
                }}
              >
                <strong>{item.name || item.firstName || '-'}</strong>
                <SuggestRankTag item={item} />
                <ViewButton icon="info" onClick={() => setShowDrawer(item.suggestDesc)} style={{ width: '83%' }}>
                  {`รายละเอียดของผู้ทรงคุณวุฒิ`}
                </ViewButton>
                {selected ? 
                <CancelButton
                  icon="close"
                  //disabled={disabled}
                  onClick={() => onClickSelect(item.id, false, item)}
                  style={{ width: '83%' }}
                >
                  ลบออกจากรายการ
                </CancelButton>
                :
                <SaveButton
                  icon="plus"
                  //disabled={disabled}
                  onClick={() => onClickSelect(item.id, true, item)}
                  style={{ width: '83%' }}
                >
                  เพิ่มเป็นผู้ทรงคุณวุฒิ
                </SaveButton>}
                
              </div>
            </Panel>
          )})}
        </Carousel> */}

        <div style={{ padding: 10, maxHeight: 400, overflowY: 'auto' }}>
          {carouselData.map((item, index) => {
            return (
              <>
                <hr />
                <Row>
                  <Col lg={1} md={1} sm={1} xs={1} style={{ width: 30 }}>
                    {`${index + 1}. `}
                  </Col>
                  <Col lg={10} md={10} sm={10} xs={10}>
                    <p style={{ fontSize: '0.9rem' }}>{item.name || '-'}</p>
                    <span style={{ fontSize: '0.8rem', fontStyle: 'italic', opacity: 0.5 }}>
                      {item.group || '-'}
                    </span>
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'center' }}>
                    <SuggestRankTag item={item} />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'end' }}>
                    <ViewButton
                      icon="info"
                      onClick={() => setShowDrawer(item.suggestDesc)}
                      style={{ margin: 0 }}
                    >
                      {`รายละเอียด`}
                    </ViewButton>
                  </Col>
                  <Col lg={5} md={5} sm={5} xs={5}>
                    {selectedExpert?.some((e) => e.id == item.id) ? (
                      <CancelButton
                        icon="close"
                        onClick={() => onClickSelect(item.id, false, item)}
                        style={{ margin: 0 }}
                        //disabled={selectedExpert?.some((e) => e.id == item.id && e.sendConsiderDate)}
                        disabled={sendedExpert.find((i) => i.id == item.id)}
                      >
                        ลบรายการออก
                      </CancelButton>
                    ) : (
                      <SaveButton
                        icon="plus"
                        onClick={() => onClickSelect(item.id, true, item)}
                        style={{ margin: 0 }}
                      >
                        เพิ่มผู้ทรงคุณวุฒิ
                      </SaveButton>
                    )}
                  </Col>
                </Row>
              </>
            )
          })}
        </div>
      </Panel>

      <Drawer
        full
        placement="top"
        show={showDrawer}
        onHide={() => setShowDrawer(false)}
        style={{ zIndex: 9999 }}
        size={fontSize <= 15 ? 'xs' : 'sm'}
      >
        <Drawer.Header>
          <Drawer.Title>
            <div style={{ paddingTop: 10 }}>{'การแนะนำ'}</div>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {/* <p style={{padding: 5}}>{showDrawer}</p> */}
          <div dangerouslySetInnerHTML={{ __html: showDrawer }}></div>
        </Drawer.Body>

        <Drawer.Footer>
          <CancelButton onClick={() => setShowDrawer(false)} children="ปิด" />
        </Drawer.Footer>
      </Drawer>

      <Drawer
        full
        placement="top"
        show={showDrawerInfoAll}
        onHide={() => setShowDrawerInfoAll(false)}
        style={{ zIndex: 9999 }}
        size={fontSize <= 15 ? 'xs' : 'sm'}
      >
        <Drawer.Header>
          <Drawer.Title>
            <div style={{ paddingTop: 10 }}>{'การแนะนำ'}</div>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>{renderSuggestionInfoAll(suggestionInfo)}</Drawer.Body>

        <Drawer.Footer>
          <CancelButton onClick={() => setShowDrawerInfoAll(false)} children="ปิด" />
        </Drawer.Footer>
      </Drawer>
    </div>
  )
}

const arrowStyle = {
  position: 'absolute',
  zIndex: 10,
  width: '40px',
  height: '40px',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  fontSize: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
